import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { MM_BREAKPOINTS } from '@metromarkets/components';
import { MediaObserver } from '@angular/flex-layout';
import { MediaAlias, MediaAliasMap } from '../models/media.model';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MediaService implements OnDestroy {

  private destroy$ = new Subject<void>();

  public get mediaAliases$(): Observable<MediaAliasMap>{
    return this._mediaAliases$.asObservable();
  }

  private readonly _mediaAliases$ = new ReplaySubject<MediaAliasMap>(1);
  private mediaAliases: MediaAliasMap;
  private readonly mediaAliasList = MM_BREAKPOINTS.map(({ alias }) => alias);

  constructor(
    private readonly mediaObserver: MediaObserver,
  ) {
    this.initialize();
  }

  public isAliasActive(targetAlias: MediaAlias): boolean {
    return this.mediaAliases[targetAlias];
  }

  private initialize(): void {
    this.mediaObserver.asObservable().pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
        this.mediaAliases = this.mediaAliasList.reduce(this.reduceMediaAliases.bind(this), {} as MediaAliasMap);
        this._mediaAliases$.next(this.mediaAliases);
      });
  }

  private reduceMediaAliases(acc: MediaAliasMap, mediaAlias: MediaAlias): MediaAliasMap {
    return {
      ...acc,
      [mediaAlias]: this.mediaObserver.isActive(mediaAlias),
    };
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
